import { Box, CircularProgress } from "@mui/material"

export const RKDSectionLoading = () => {
    const style = {
        root: {
            display: 'flex',
            justifyContent: 'center',
            p: 2
        }
    }
    
    return <Box sx={style.root}><CircularProgress /></Box>
}